import React from 'react'

import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path d="M7.0438 22H16.9562C18.3255 22 19 21.3337 19 19.8597V12.2978C19 10.9652 18.4482 10.2887 17.3036 10.1777V7.684C17.3036 3.84755 14.7182 2 12 2C9.28175 2 6.69635 3.84755 6.69635 7.684V10.208C5.63358 10.3695 5 11.0358 5 12.2978V19.8597C5 21.3337 5.67445 22 7.0438 22ZM8.65839 7.50227C8.65839 5.14992 10.1708 3.85765 12 3.85765C13.819 3.85765 15.3416 5.14992 15.3416 7.50227V10.1575L8.65839 10.1676V7.50227Z" />,
  'Lock',
)
